import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation, Scrollbar } from 'swiper';
import { getDisplayMode } from '../common/libs.js';

const setGallery = () => {
  const targetSliders = document.querySelectorAll(".js-gallery-slider");

  targetSliders.forEach(GallerySlider => {
    const slideLength = GallerySlider?.querySelectorAll(".swiper-slide").length;
    let first = false;
    let windowWidth = GallerySlider?.clientWidth;
    let slideSize = 0;
    let slideSpace = 0;
    if (getDisplayMode() == 1) {
      slideSize = 430;
    } else {
      slideSize = 187.5;
    }
    let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));

    // const GallerySection = GallerySlider.closest('.section-gallery')

    if (slideLength > viewSlideLength) {
      var swiper = new Swiper(GallerySlider, {
        modules: [Pagination, Autoplay, Navigation, Scrollbar],
        autoplay: {
          disableOnInteraction: false,
          delay: 0,
        },
        speed: 15000,
        loopedSlides: slideLength,
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: slideSpace,
        // pagination: {
        //   el: GallerySection.querySelector('.swiper-pagination'),
        //   clickable: true,
        //   type: 'bullets',
        // },
        // scrollbar: {
        //   el: GallerySection.querySelector('.swiper-scrollbar'),
        //   draggable: true,
        // },
        // navigation: {
        //   nextEl: GallerySection.querySelector('.swiper-button-next'),
        //   prevEl: GallerySection.querySelector('.swiper-button-prev'),
        // },
        // breakpoints: {
        //   768: {
        //     slidesPerView: 'auto',
        //     // centeredSlides: true
        //   }
        // },
        on: {
          // slideChange: function () {
          //   if (!first) {
          //     this.params.autoplay.delay = 3500;
          //   } else {
          //     this.params.autoplay.delay = 3000;
          //   }
          // },
          afterInit: function () {
            first = true;
            setGalleryModal();
          },
          // touchEnd: (slider) => {
          //   slider.slideTo(slider.activeIndex + 1);
          // },
        }
      });
    } else {
      GallerySlider?.classList.add('slide-none');
      setGalleryModal();
    }

    GallerySlider?.classList.add('is-init')
  })
};

export default setGallery;


const setGalleryModal = () => {
  const body = document.querySelector('body');

  function openModal(target) {
    target.classList.add('is-open');
    body.classList.add('no-scroll');
  }

  function closeModal(target) {
    target.classList.remove('is-open');
    body.classList.remove('no-scroll');
  }

  const triggers = document.querySelectorAll('.js-modal-trigger');

  triggers.forEach((trigger) => {
    const contentsId = trigger.getAttribute('modal-content');
    const target = document.getElementById(contentsId);
    if (!target) return;

    const closeBtn = target.querySelector('.modal-close');
    const modalBg = target.querySelector('.modal-bg');

    trigger.addEventListener('click', function (e) {
      e.preventDefault();

      const index = trigger.dataset.index;

      const allItems = target.querySelectorAll('.modal-item');
      allItems.forEach(item => {
        item.style.display = 'none';
      });

      const currentItem = target.querySelector(`.modal-item[data-index="${index}"]`);
      if (currentItem) currentItem.style.display = 'block';

      openModal(target);
    });

    closeBtn?.addEventListener('click', () => closeModal(target));
    modalBg?.addEventListener('click', () => closeModal(target));
  });
};